import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import GroupSearchFeedbackActions from 'app/actions/GroupSearchFeedbackActions';
import GroupSearchFeedback from './GroupSearchFeedback';

function GroupSearchFeedbackContainer(props) {
  return <GroupSearchFeedback {...props} />;
}

const mapStateToProps = state => ({
  shouldMatch: state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']),
  isEditing: state.getIn(['ui', 'groupSearchFeedback', 'isEditing']),
  isSubmitting: state.getIn(['ui', 'groupSearchFeedback', 'isSubmitting']),
  sourceBib: state.getIn(['entities', 'bibs', state.getIn(['ui', 'groupSearchFeedback', 'metadataId1'])]),
  bibToMatch: state.getIn(['entities', 'bibs', state.getIn(['ui', 'groupSearchFeedback', 'metadataId2'])]),
  isMissingRequiredFields: state.getIn(['ui', 'groupSearchFeedback', 'isMissingRequiredFields'])
});

const mapDispatchToProps = dispatch => ({
  groupSearchFeedbackActions: bindActionCreators(GroupSearchFeedbackActions, dispatch)
});

GroupSearchFeedbackContainer.propTypes = {
  groupSearchFeedbackActions: PropTypes.objectOf(PropTypes.func),
  sourceBib: ImmutablePropTypes.map,
  bibToMatch: ImmutablePropTypes.map,
  shouldMatch: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  searchResults: ImmutablePropTypes.list,
  isMissingRequiredFields: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupSearchFeedbackContainer);
